export default "__VITE_ASSET__c42318c2__"